import _toConsumableArray from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import React__default from 'react';
import { u as uuidv4 } from '../uuid-717930b4.js';
var componentClassName = 'sendbird-sort-by-row';
function SortByRow(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    maxItemCount = _ref.maxItemCount,
    itemWidth = _ref.itemWidth,
    itemHeight = _ref.itemHeight,
    children = _ref.children;
  if (Array.isArray(children) && children.length > maxItemCount) {
    var result = [];
    for (var i = 0; i < children.length; i += maxItemCount) {
      result.push(/*#__PURE__*/React__default.createElement("div", {
        className: [].concat(_toConsumableArray(Array.isArray(className) ? className : [className]), [componentClassName]).join(' '),
        key: uuidv4(),
        style: {
          width: itemWidth * maxItemCount,
          height: itemHeight
        }
      }, children.slice(i, i + maxItemCount)));
    }
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, result);
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: [].concat(_toConsumableArray(Array.isArray(className) ? className : [className]), [componentClassName]).join(' '),
    style: {
      width: itemWidth * (Array.isArray(children) ? children.length : 1),
      height: itemHeight
    }
  }, children);
}
export { SortByRow as default };